import React, { useState, useEffect, useRef } from "react";
import "./CreatePublishHomework.css";
import Switch from "@mui/material/Switch";
import SuccessfullHomework from "../create_successfull/SuccessfullHomework";
import { MultiSelect } from "react-multi-select-component";
import {
  DatePickerComponent,
  TimePickerComponent,
  DateTimePickerComponent,
} from "@syncfusion/ej2-react-calendars";
import axios from "../../../../axios";
import ResponseLoding from "../../../Pre-read/Create_Assessment_PreRead/create_successfullPreRead/ResponseLoding";
import moment from "moment";
import ErrorDialog from "../../../../Assesment/pages/Create_Assessment/create_published/ErrorDialogue";
import { toast } from "react-toastify";

const CreatePublishHomework = ({
  setClick,
  questions,
  assessmentDetails,
  setAssessmentDetails,
}) => {
  const assessmentDialogRef = useRef();
  const [checked, setChecked] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isError, setIsError] = useState(false);
  const today = new Date();
  const minDateTime = new Date(today.getTime() + 30 * 60000);
  const disablePastDates = (date) => {
    return date < today;
  };
  console.log(assessmentDetails);
  const currentDate = new Date();
  const [studentList, setStudentList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [lectures, setLectures] = useState();
  const [isInProgress, setIsInProgress] = useState(false);
  const [lectureDate, setLectureDate] = useState();
  console.log(lectureDate);
  let schoolId = JSON.parse(localStorage.getItem("schoolId"));
  let academicYearId = JSON.parse(localStorage.getItem("academicYearId"));
  let timeTableSessionId = JSON.parse(
    localStorage.getItem("timeTableSessionId")
  );

  useEffect(() => {
    let students = [];
    const getStudentList = async () => {
      if (!timeTableSessionId) {
        return;
      }
      try {
        let res = await axios.get(
          `/api/v1/school/student/getList?standardId=${assessmentDetails?.standard_id?.id}&sectionId=${assessmentDetails?.section_id?.id}&timetableSession=${timeTableSessionId}`
        );

        res &&
          res.data.data.map((student) =>
            students.push({ value: student.id, label: student.name })
          );

        setStudentList(students);
      } catch (error) {
        console.log(error);
      }
    };

    getStudentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const getLiveLectureList = async () => {
      if (!academicYearId || !timeTableSessionId) {
        toast.error("These are no allocations set for your login. Please contact school admin for the assistance.")
        return;
      }
      try {
        if (assessmentDetails?.deadline) {
          let lectures = await axios.get(
            `/api/v1/timetable/getLectureBySubject/academicYearId/${academicYearId}/schoolId/${schoolId}/standardId/${assessmentDetails?.standard_id?.id}/sectionId/${assessmentDetails?.section_id?.id}/timetableSessionId/${timeTableSessionId}/subjectId/${assessmentDetails?.subject_id?.id}/date/${lectureDate}`
          );
          lectures && setLectures(lectures?.data?.data[0].lectures);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getLiveLectureList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lectureDate]);

  const handleStudentSelection = (selected) => {
    setSelectedList(selected);
  };

  const dateHelper = (a) => {
    console.log(a);
    const dateObj = new Date(a);
    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const outputDateString = `${year}-${month}-${day}`;
    return outputDateString;
  };
  function convertDateFormat(inputDate) {
    const [day, month, year] = inputDate.split("-");
    const dateObject = new Date(`${year}-${month}-${day}`);
    const convertedYear = dateObject.getFullYear();
    const convertedMonth = String(dateObject.getMonth() + 1).padStart(2, "0");
    const convertedDay = String(dateObject.getDate()).padStart(2, "0");
    const convertedDate = `${convertedYear}-${convertedMonth}-${convertedDay}`;
    return convertedDate;
  }

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const outputDateString = `${hours}:${minutes}`;
    return outputDateString;
  };

  const handleCreateAssessment = async () => {
    setIsInProgress(true);
    let newAssessment = {
      name: assessmentDetails.name,
      description: assessmentDetails.description,
      type_id: assessmentDetails.type_id,
      standard_id: assessmentDetails.standard_id?.id,
      subject_id: assessmentDetails.subject_id?.id,
      teacher_id: assessmentDetails.teacher_id,
      section_id: assessmentDetails.section_id?.id,
      tags: assessmentDetails.tags,
      status: "published",
      total_duration: assessmentDetails.total_duration || 0,
      deadline: assessmentDetails.deadline,
      schedule_date: assessmentDetails.schedule_date,
      schedule_time: assessmentDetails.schedule_time,
      add_to_live_session: assessmentDetails.add_to_live_session,
      questions: questions.map((question) => {
        if (
          question.correct_score === null ||
          question.correct_score === undefined
        ) {
          return { ...question, correct_score: 0 };
        }
        return question;
      }),
    };
    let students_id = [];
    for (const student of selectedList) {
      students_id.push(student.value);
    }
    try {
      let res = await axios.post(`/api/v1/homework/create`, newAssessment);
      if (res) {
        let students_id = [];
        for (const student of selectedList) {
          students_id.push(student.value);
        }
        let newStudentAssessment = {
          teacher_id: assessmentDetails?.teacher_id,
          student_id: students_id,
          status: "pending",
          deadline: assessmentDetails?.deadline,
        };
        let studentRes = await axios.post(
          `/api/v1/homework/${res?.data?.data?.id}/studentHomework/create`,
          newStudentAssessment
        );
        studentRes && setSuccess(!success);
      }
    } catch (error) {
      setIsInProgress(false);
      console.log(error);
      setIsError(true);
      if (error.response.data.message) {
        setErrorMessage(error.response.data.message);
      }
      assessmentDialogRef.current.openDialog();
    }
  };

  const removeDup = (studentList) => {
    const valueMap = new Map();
    const uniqueStudents = [];

    studentList.forEach((student) => {
      if (!valueMap.has(student.value)) {
        valueMap.set(student.value, true);
        uniqueStudents.push(student);
      }
    });
    return uniqueStudents;
  };

  function formatDate(inputDate) {
    const dateObject = new Date(inputDate);

    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }
  const deadline = assessmentDetails?.deadline;
  console.log(deadline);
  if (deadline) {
    var minLiveSessionDate = new Date(deadline);
    minLiveSessionDate.setDate(minLiveSessionDate.getDate() - 7);

    var maxLiveSessionDate = new Date(deadline);
    maxLiveSessionDate.setDate(maxLiveSessionDate.getDate() + 28);
  }
  function convertTimeStringToAMPM(timeString) {
    if (timeString.length !== 4) {
      // Ensure the input string has the correct length
      console.error("Invalid time string format");
      return null;
    }

    const hours = timeString.substring(0, 2);
    const minutes = timeString.substring(2);

    const formattedTime = `${hours}:${minutes} ${hours < 12 ? "AM" : "PM"}`;
    return formattedTime;
  }
  return (
    <>
      <ErrorDialog
        error={"Cannot create Homework"}
        message={errorMessage}
        ref={assessmentDialogRef}
        setIsError={setIsError}
      />
      {!success && (
        <div className="publish_transprant_body1">
          <div className=" p-4 publish_white_containerPre">
            <img
              src="/images/cross-circle3.svg"
              className="subPrereadClosetBtn"
              alt=""
              onClick={(e) => setClick(false)}
            />
            <h5 className="publish_header">Publish</h5>
            <div className=" col-12 publish_field_boxs">
              {assessmentDetails?.subject_id?.name}
            </div>
            <div className=" col-12 publish_field_boxs">
              {assessmentDetails?.standard_id?.name}
            </div>
            <div className=" col-12 publish_field_boxs">
              {assessmentDetails?.section_id?.name}
            </div>
            <div className=" col-12 m-0 p-0 px-2 EnterDeadlinePreread">
              <DateTimePickerComponent
                allowEdit={false}
                min={minDateTime}
                isDateDisabled={disablePastDates}
                placeholder="Deadline"
                id="datepicker"
                minDate={currentDate}
                onChange={(e) => {
                  if (!e.target.value) {
                    setAssessmentDetails({
                      ...assessmentDetails,
                      deadline: "",
                    });
                  } else {
                    setAssessmentDetails({
                      ...assessmentDetails,
                      //deadline: dateHelper(e.target.value),
                      deadline: e.target.value,
                    });
                  }
                }}
              />
            </div>

            <div className="my-3">
              <MultiSelect
                options={removeDup(studentList)}
                value={selectedList}
                onChange={handleStudentSelection}
                labelledBy="Select"
                className="custom-multiselect w-100"
              />
            </div>

            <div className="btn_containers">
              <div className="toggle_btn">
                <div className=" schedule_btns">
                  {deadline ? (
                    <label className="switch p-0 m-0">
                      <DatePickerComponent
                        id="datepicker"
                        placeholder="Add to Live Sessio"
                        width={230}
                        isDateDisabled={true}
                        min={minLiveSessionDate}
                        max={maxLiveSessionDate}
                        allowEdit={false}
                        onChange={(e) => {
                          setChecked1(true);
                          setLectureDate(formatDate(e.target.value));
                          console.log(typeof e.target.value);
                        }}
                      />
                    </label>
                  ) : (
                    <>
                      <label className="deadlineNotSelect">
                        Add to Lecture Session
                      </label>
                      <img
                        src="/images/calIconDow.png"
                        alt=""
                        className="calDow"
                      />
                    </>
                  )}
                </div>
                {checked1 && (
                  <div className="schedule_box border-0 p-0">
                    <select
                      className="form-select col-12 py-2 m-0  "
                      id="Schedule_sesion"
                      onChange={(e) =>
                        setAssessmentDetails({
                          ...assessmentDetails,
                          add_to_live_session: {
                            lecture_id: e.target.value,
                            date: convertDateFormat(
                              e.target.options[
                                e.target.selectedIndex
                              ].getAttribute("schdate")
                            ),
                          },
                        })
                      }
                    >
                      <option selected>Select Lecture</option>
                      {lectures?.length > 0 &&
                        lectures?.map((lecture, index) => (
                          <option
                            key={index}
                            value={lecture.id}
                            schdate={lecture.date}
                          >
                            {lecture.name}, {lecture.date},{" "}
                            {convertTimeStringToAMPM(lecture.start_time)}-
                            {convertTimeStringToAMPM(lecture.end_time)}
                          </option>
                        ))}
                    </select>
                  </div>
                )}
              </div>
            </div>

            <div className="publish_btn_box">
              <button
                disabled={
                  !assessmentDetails.deadline ||
                  !(selectedList.length > 0) ||
                  (checked1 && lectures?.length > 0 &&
                    (!assessmentDetails.add_to_live_session.lecture_id ||
                      !assessmentDetails.add_to_live_session.date))
                }
                className="btn publish_btn"
                onClick={handleCreateAssessment}
              >
                Publish
              </button>
            </div>
          </div>
        </div>
      )}
      {success && <SuccessfullHomework />}
      {!success && isInProgress && (
        //   <div className=" successful_preview_transprant_body ">
        //   <div className=" p-2 successful_preview_container shadow">
        //   <div className="loader_bg1">
        //     {/* <img className="qList_loader" src="/gif/LoaderDot.gif" alt="" /> */
        //     }
        //     <img className="qList_loader_p" src="/images/PublishingLoader.svg" alt="" />
        //   </div>
        //   </div>
        // </div>
        <ResponseLoding />
      )}
    </>
  );
};

export default CreatePublishHomework;
